import axios from '@/libs/api.request'

export const page = (data) => {
  return axios.request({
    url: '/weChat/v2/member/page',
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/member-buy-record.js